import md5 from 'blueimp-md5'

export function getBodyJava(method, obj) {
  // params 顺序不能更改 否则要进行ASCII码排序 加密内容
  let params = {
    appid: 'fubeiapp',
    content: '',
    method,
    salt: '8kmVCQHr', // 加盐 加密完之后需要从params删除
    version: '1.0.0'
  }
  obj.accessToken = localStorage.getItem('access_token')
  params.content = JSON.stringify(obj || '')
  // 加密的时候需要去掉反斜杠
  var reg = new RegExp('\\\\', 'g')
  let body = JSON.stringify(params).replace(reg, '')
  let sign = md5(body)
  if (params.salt) delete params.salt

  let javaParam = 'appid=fubeiapp' + '&method=' + method + '&sign=' + sign + '&version=1.0.0' + '&content=' + encodeURIComponent(JSON.stringify(obj))
  return javaParam
}

/*
 * app重构后的加签
 */
export function getBodyJavaNew(method, obj) {
  // params 顺序不能更改 否则要进行ASCII码排序 加密内容
  let params = {
    appid: 'fubeiapp',
    content: '',
    method,
    salt: '8kmVCQHr', // 加盐 加密完之后需要从params删除
    version: '1.0'
  }
  obj.accessToken = localStorage.getItem('access_token')
  params.content = JSON.stringify(obj || '')
  // 加密的时候需要去掉反斜杠
  var reg = new RegExp('\\\\', 'g')
  let body = JSON.stringify(params).replace(reg, '')
  let sign = md5(body)
  if (params.salt) delete params.salt

  let javaParam = 'appid=fubeiapp' + '&method=' + method + '&sign=' + sign + '&version=1.0' + '&content=' + encodeURIComponent(JSON.stringify(obj))
  return javaParam
}

/**
 * 解析字符串为对象
 * @param {*} data
 * @returns obj
 */
export function queryToObj (data) {
  let obj = {}
  let strs = data.split('&')
  for (let i = 0; i < strs.length; i++) {
    obj[strs[i].split('=')[0]] = decodeURIComponent(strs[i].split('=')[1])
  }
  return obj
}
